/**
 * httpリクエスト処理
 */

import common from '@/mixin/common';
import * as constants from '@/mixin/constants';
// Ajax通信ライブラリ
import 'whatwg-fetch';

const URL = '';

export default {
  created: function () {
    this.URL = process.env.WEB_API_ORIGIN + "/rosettaapi/";
  },
  mixins: [
    common,
  ],
  methods: {
    /**
     * API送信用のスコアデータを作成
     */
    createScoreDataForApi: function (levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, ok, ng, skip) {
      var res = [];

      var key = constants.DATA_SCORE + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex + '-' + pathstepIndex;
      var okVal = '{"' + key + '-ok":"' + ok + '"}';
      var ngVal = '{"' + key + '-ng":"' + ng + '"}';
      var skipVal = '{"' + key + '-skip":"' + skip + '"}';

      res.push(okVal);
      res.push(ngVal);
      res.push(skipVal);

      return res.toString();
    },
    /**
     * リセットするためのAPI送信用のスコアデータを作成
     */
    createResetScoreDataForApi: function (levelNo, unitNo, lessonIndex, pathIndex, pathstepLen) {
      var res = [];

      for (var i=0; i < pathstepLen; i++) {
        var key = constants.DATA_SCORE + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex + '-' + i;
        var okVal = '{"' + key + '-ok":"0"}';
        var ngVal = '{"' + key + '-ng":"0"}';
        var skipVal = '{"' + key + '-skip":"0"}';

        res.push(okVal);
        res.push(ngVal);
        res.push(skipVal);
      }

      return res.toString();
    },
    /**
     * API送信用の進捗データを作成
     */
    createProgressDataForApi: function (levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
      var key = constants.DATA_PROGRESS + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex;
      var val = '{"' + key + '":"' + pathstepIndex + '"}';
      return val;
    },
    /**
     * API送信用の学習状態データを作成
     */
    createStudyStatusDataForApi: function (studying) {
      var val = '{"' + constants.DATA_STUDY_STATE + '":"' + studying + '"}';
      return val;
    },
    /**
     * API送信用のリビジョンデータを作成
     */
    createRevisionDataForApi: function (levelNo, unitNo, lessonIndex, pathIndex, revision) {
      var key = constants.DATA_REVISION + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex;
      var val = '{"' + key + '":"' + revision + '"}';
      return val;
    },
    /**
     * API送信用のpathstep数のデータを作成
     */
     createPathStepLengthForApi: function(levelNo, unitNo, lessonIndex, pathIndex, length) {
       var key = constants.DATA_PATHSTEP_LENGTH + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex;
       var val = '{"' + key + '":"' + length + '"}';
       return val;
     },
     /**
      * API送信用の回答が必要な問題数のデータを作成
      */
      createPathStepChallengeForApi: function(levelNo, unitNo, lessonIndex, pathIndex, pathStepIndex, challenge) {
        var key = constants.DATA_PATHSTEP_CHALLENGE + levelNo + '-' + unitNo + '-' + lessonIndex + '-' + pathIndex + '-' + pathStepIndex;
        var val = '{"' + key + '":"' + challenge + '"}';
        return val;
      },
    /**
     * HTTPリクエスト
     *
     * @param {String} path URL拡張パス
     * @param {String} method HTTPメソッド
     * @param {String} param リクエストパラメータ
     * @param {String} accessKey アクセスキー(未指定可)
     */
    request: function (path, method, param, accessKey) {
      var self = this;
      var headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };

      // アクセスキー設定
      if (accessKey) {
        headers['X-RS-Access-Key'] = accessKey;
      }

      // fetchオプションの設定
      var options = {
        method: method,
        mode: 'cors',
        credentials: 'include',
        headers: headers,
      };

      // リクエストパラメータ
      if (param) {
        options.body = param;
      }

      // リクエスト実行
      return new Promise(function(resolve, reject) {
        fetch(self.URL + path, options).then(function (response) {
          self.log(path + " response.status: " + response.status);
          if (response.status != 200) {
            reject(response.status);
          }

          resolve(response.json());
        }).catch (function(error) {
          self.log(path + " error: " +　error);
          reject('');
        });
      });
    },
    /**
     * HTTPリクエスト(アクセスキー付与)
     *
     * @param {String} path URL拡張パス
     * @param {String} method HTTPメソッド
     * @param {String} param リクエストパラメータ
     * @param {String} accessKey アクセスキー(未指定可)
     */
    requestWithAccessKey: async function (path, method, param, accessKey) {
      // アクセスキーが指定されなかった場合、ここで取得
      var key = accessKey;
      if (!key) {
        key = await storage_wrapper.getRsAccessKey();
      }
      // HTTPリクエスト
      return this.request(path, method, param, key);
    },
    /**
     * ログインAPI
     *
     * @param {String} email メールアドレス
     * @param {String} password パスワード
     */
    login: function (email, password) {
      this.log("http start login");
      // 入力パラメータの設定
      var param = 'email=' + encodeURIComponent(email) + '&password=' + password;
      // HTTPリクエスト
      return this.request('login', 'POST', param);
    },
    /**
     * シリアル入力API
     *
     * @param {String} contentid コンテンツID
     * @param {String} serial シリアル
     * @param {String} accessKey アクセスキー(未指定可)
     */
    activate: function (contentid, serial, accessKey) {
      this.log("http start activate");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&serial=' + serial;
      // HTTPリクエスト
      return this.requestWithAccessKey('activate', 'POST', param, accessKey);
    },
    /**
     * ライセンスチェックAPI
     *
     * @param {String} contentid コンテンツID
     * @param {String} accessKey アクセスキー(未指定可)
     */
    checkLicense: function (contentid, accessKey) {
      this.log("http start checkLicense");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid;
      // HTTPリクエスト
      return this.requestWithAccessKey('checklicense', 'POST', param, accessKey);
    },
    /**
     * key-value取得API
     *
     * @param {String} contentid コンテンツID
     * @param {String} keyname
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getKeyValue: function (contentid, keyname, accessKey) {
      this.log("http start getKeyValue keyname: " + keyname);
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&keyname=' + keyname;
      // HTTPリクエスト
      return this.requestWithAccessKey('getkeyvalue', 'POST', param, accessKey);
    },
    /**
     * key-value設定API
     *
     * @param {String} contentid コンテンツID
     * @param {String} datajson
     * @param {String} accessKey アクセスキー(未指定可)
     */
    setKeyValue: function (contentid, datajson, accessKey) {
      this.log("http start setKeyValue");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&datajson=' + datajson;
      // HTTPリクエスト
      return this.requestWithAccessKey('setkeyvalue', 'POST', param, accessKey);
    },
    /**
     * ログアウトAPI
     */
    logout: function () {
      this.log("http start logout");
      // HTTPリクエスト
      return this.requestWithAccessKey('logout', 'GET');
    },
    /**
     * アクセスキー取得API
     *
     * @param {String} onetimekey ワンタイムキー
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getAccessKey: function (oneTimeKey, accessKey) {
      this.log("http start getAccessKey");
      // 入力パラメータの設定
      var param = 'onetimekey=' + oneTimeKey;
      // HTTPリクエスト
      return this.request('getaccesskey', 'POST', param, accessKey);
    },
    /**
     * 進捗率設定API
     *
     * @param {String} contentid コンテンツID
     * @param {String} progress 進捗率
     * @param {String} accessKey アクセスキー(未指定可)
     */
    registerProgress: function (contentid, progress, accessKey) {
      this.log("http start registerProgress");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&progress=' + progress;
      // HTTPリクエスト
      return this.requestWithAccessKey('registerprogress', 'POST', param, accessKey);
    },
    /**
     * 復号キー取得API
     *
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getDecryptionKeys: function (accessKey) {
      this.log("http start getDecryptionKeys");
      // HTTPリクエスト
      return this.requestWithAccessKey('getdecryptionkeys', 'GET', null, accessKey);
    },
    /**
     * 引き継ぎコード取得API
     *
     * @param {String} password パスワード
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getTakeOverCode: function (password, accessKey) {
      this.log("http start getTakeOverCode");
      // 入力パラメータの設定
      var param = 'passhash=' + this.getSha256HashHexString(password);
      // HTTPリクエスト
      return this.requestWithAccessKey('gettakeovercode', 'POST', param, accessKey);
    },
    /**
     * au版Androidアプリ利用開始API
     *
     * @param {String} uuid Androidアプリで生成されたUUID
     */
    auActivate: function (uuid) {
      this.log("http start auActivate");
      // 入力パラメータの設定
      var param = 'uuid=' + uuid;
      // HTTPリクエスト
      return this.request('auactivate', 'POST', param);
    },
    /**
     * softbank版Androidアプリ利用開始API
     *
     * @param {String} uuid Androidアプリで生成されたUUID
     */
    softbankActivate: function (uuid) {
      this.log("http start softbankActivate");
      // 入力パラメータの設定
      var param = 'uuid=' + uuid;
      // HTTPリクエスト
      return this.request('softbankactivate', 'POST', param);
    },
    /**
     * 引き継ぎコード利用開始API
     *
     * @param {String} takeOverCode 引継ぎコード
     * @param {String} password パスワード
     */
    takeOverActivate: function (takeOverCode, password) {
      this.log("http start takeOverActivate");
      // 入力パラメータの設定
      var param = 'takeovercode=' + takeOverCode + '&passhash=' + this.getSha256HashHexString(password);
      // HTTPリクエスト
      return this.request('takeoveractivate', 'POST', param);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/http.js